// searchbar toggle
const toggle = document.querySelector('[data-search-toggle="search"]')

const searchbar = document.querySelector('[data-search="search"]')

const input	= searchbar.querySelector('.search-field')
const body = document.querySelector('body')


toggle.addEventListener('click', (e) => {
	e.preventDefault()
	body.classList.toggle('search-active')
	searchbar.classList.toggle('active')
	toggle.classList.toggle('active')

	input.focus()
})

const close = document.querySelector('[data-search-close="search"]')

close.addEventListener('click', (e) => {
	e.preventDefault()
	body.classList.remove('search-active')
	searchbar.classList.remove('active')
	toggle.classList.remove('active')

	input.blur()
})
